import { render } from "./TemplateBasic.vue?vue&type=template&id=1a175ebb&scoped=true&ts=true"
import script from "./TemplateBasic.vue?vue&type=script&lang=ts"
export * from "./TemplateBasic.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a175ebb"]])

export default __exports__